/* eslint-disable import/prefer-default-export */
import { lastQuarter, past3Months, past6Months, past12Months, thisQuarter } from 'constants/ProjectConstants';

// ACCORDING TO THE NEW DESIGN FOR DATE RANGE COMPONENT, WE WILL ONLY HAVE 4 VALUES
// THIS QUARTER, LAST QUARTER,  PAST 6 MONTHS, PAST 12 MONTHS
const getDefaultRanges = (date) => [
  thisQuarter,
  lastQuarter,
  past3Months,
  past6Months,
  past12Months,

  // THIS WOULD BE DEPRECATED WITH THE NEW DESIGN
  // {
  //   label: 'This Month',
  //   startDate: startOfMonth(date),
  //   endDate: endOfMonth(date)
  // },
  // {
  //   label: 'Last Month',
  //   startDate: startOfMonth(addMonths(date, -1)),
  //   endDate: endOfMonth(addMonths(date, -1))
  // },
  // {
  //   label: 'Last 2 Month',
  //   startDate: subMonths(startOfMonth(new Date()), 2),
  //   endDate: subSeconds(startOfMonth(new Date()), 1)
  // },
  // {
  //   label: 'This Year',
  //   startDate: startOfYear(new Date()),
  //   endDate: endOfYear(new Date())
  // }
];

export const defaultRanges = getDefaultRanges(new Date());
